import { IStepGeometry } from '@stair-craft/common/util';

/** A point of a handrail over a straight flight: how far along the climb, and how high. */
export interface IFlightRailAnchor {
    readonly along: number;
    readonly y: number;
}

/** The handrail line over a straight flight, the same for both of its sides. */
export interface IFlightRail {
    readonly from: IFlightRailAnchor;
    readonly to: IFlightRailAnchor;
}

/**
 * The handrail line over a flight that leaves a turn: from the rail height above the first tread's
 * nose tip to the top of the post at the upper floor. `noseAlong` and `top.along` are measured along
 * the climb. Both sides of the flight take this one line, so in a view along the flight their rails
 * coincide, and the rail runs at the rail height above the nosing line.
 */
export function flightRail(firstStep: IStepGeometry, noseAlong: number, railHeight: number, top: IFlightRailAnchor): IFlightRail {
    return { from: { along: noseAlong, y: firstStep.position.y + railHeight }, to: top };
}

/** The handrail height of a flight rail at a distance along the climb. */
export function flightRailY(rail: IFlightRail, along: number): number {
    const span: number = rail.to.along - rail.from.along;
    if (Math.abs(span) < 1e-6) {
        return rail.from.y;
    }
    return rail.from.y + ((along - rail.from.along) / span) * (rail.to.y - rail.from.y);
}
